import { useEffect, useRef, useState } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import ConfettiCannon from 'react-native-confetti-cannon';

/** Mount only when celebrating. No idle particles and no finished pile. */
export default function ConfettiBurst({ count = 120 }: { count?: number }) {
  const cannon = useRef<ConfettiCannon | null>(null);
  const [finished, setFinished] = useState(false);
  const { width } = useWindowDimensions();

  useEffect(() => {
    const animation = cannon.current;
    animation?.start();
    return () => animation?.stop();
  }, []);

  if (finished) return null;

  return (
    <View pointerEvents="none" style={styles.overlay} testID="confetti-overlay" accessibilityElementsHidden importantForAccessibility="no-hide-descendants">
      <ConfettiCannon
        ref={cannon}
        count={count}
        origin={{ x: width / 2, y: -30 }}
        autoStart={false}
        fadeOut
        onAnimationEnd={() => setFinished(true)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: { ...StyleSheet.absoluteFillObject, overflow: 'hidden' },
});
